import http from "plugins/axios";

export default {
  delHistory(symbol){
    return http.post({
      url:`/la/admin/kline/del?symbol=${symbol}`,
    
    })
  },
  repairKline({ symbol, repairStartTime, repairEndTime,param }) {
    return http.get({
      url: `/la/admin/kline/import?symbol=${symbol}&repairStartTime=${repairStartTime}&repairEndTime=${repairEndTime}&param=${param}`,
    });
  },
  getAllCoin() {
    return http.get({
      url: "/la/admin/coin/all",
    });
  },
  getTradePairList({ pair, area, page, size }) {
    return http.post({
      url: "/la/admin/tradePair/list",
      data: {
        pair,
        area,
        page,
        size,
      },
      dataType: "form",
    });
  },
  updateTradeStatus({ pair, status, amount, price }) {
    return http.post({
      url: `/la/admin/tradePair/update/${pair}/trade/${status}`,
      data: { amount, price },
      dataType: "form",
    });
  },
  createTradePair(data) {
    return http.post({
      url: "/la/admin/tradePair/create",
      data,
      dataType: "form",
    });
  },
  updateTradePair(data) {
    return http.post({
      url: "/la/admin/tradePair/update/type",
      data,
      dataType: "form",
    });
  },
  removeTradePair(pair) {
    return http.post({
      url: "/la/admin/tradePair/remove",
      data: {
        pair,
      },
      dataType: "form",
    });
  },
  updateDefaultPrecision({ pair, precision }) {
    return http.post({
      url: "/la/admin/tradePair/update/defaultPrecision",
      data: {
        pair,
        precision,
      },
      dataType: "form",
    });
  },
  updateAmountPrecision({ pair, precision }) {
    return http.post({
      url: "/la/admin/tradePair/update/amountPrecision",
      data: {
        pair,
        precision,
      },
      dataType: "form",
    });
  },
  transaction(pair) {
    return http.post({
      url: "/la/admin/transaction",
      data: {
        pair,
      },
      dataType: "form",
    });
  },
  getTradeArea() {
    return http.get({
      url: "/la/admin/tradePair/area",
     
    });
  },
  updateSort({ pair, orderNo }) {
    return http.post({
      url: `/la/admin/tradePair/update/${pair}/sort`,
      data: {
        pair,
        orderNo,
      },
      dataType: "form",
    });
  },
};
